/**
 * Stamps the product's name and mark onto the document at boot, from `brand.ts`.
 *
 * `index.html` is a static file Vite serves before any script runs, so it has to carry *a*
 * `<title>` and *a* favicon for the half-second before this executes — and that static copy is
 * the one place the product name and a logo path cannot be routed through the token package
 * without a build plugin. Everything from this call onwards reads from `brand.ts`, so a resale
 * that edits that file gets the tab title, the favicon and the touch icon along with the rest.
 */

import { brand, neutralBrand } from '@pos/tokens';

/**
 * `mark` defaults to the generic shopfront rather than the product's own. Boot is the signed-out
 * moment by definition — the access token is memory-only, so every cold load starts with no shop
 * — and stamping OriTech's mark into the tab there put one shop's artwork on every other shop's
 * till. Callers that know the shop pass its mark instead.
 */
export function applyBrand(title: string, mark: string = neutralBrand.mark): void {
  document.title = title;

  for (const rel of ['icon', 'apple-touch-icon']) {
    const link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
    if (link !== null) link.href = mark;
  }
}

export { brand };
